<template>
  <tr class="vcv-table-row">
    <td class="column column-checkbox">
      <vchecklabel v-model="selected" />
    </td>

    <td class="column-date">
      {{ createdAt }}
    </td>
    <td class="column-vacancy">
      <div class="row-nowrap" :title="vacancy.name">
        <router-link :to="`vacancies/${vacancy.id}`">{{ vacancy.name }}</router-link>
      </div>
      <span v-if="!vacancy.is_active" class="archive-label">
        {{ $tr('vacancies.archiveLabel') }}
      </span>
    </td>
    <td class="column-name">
      <div>
        <router-link :to="`responses/${responseId}`" class="column-name-link">
          <span>{{ candidateFullName }}</span>
          <span v-if="isInternalCandidate" class="candidate-inner-icon-container">
            <i v-tooltip="$tr('invites.internalCandidate')" class="icon icon-profile"></i>
          </span>
        </router-link>
      </div>
    </td>
    <td class="column-status">
      <span v-if="statusResponse">{{ statusResponse.name }}</span>
    </td>
    <td class="column-email">
      <div class="row-nowrap" :title="candidate.email">
        <router-link :to="`responses/${responseId}`">{{ candidate.email }}</router-link>
      </div>
    </td>
    <td class="column-phone">
      {{ candidate.phone }}
    </td>
    <td class="column-creator">
      <div class="row-nowrap" :title="invite_creator">
        <span>{{ invite_creator }}</span>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ProcessInvitesRow',

  props: {
    model: Object
  },

  computed: {
    selected: {
      get() {
        return this.$store.getters['invites/isSelected'](this.model);
      },

      set(val) {
        this.$store.commit('invites/select', {
          model: this.model,
          value: val
        });
      }
    },

    statusResponse() {
      return this.response ? this.response.status : {};
    },

    candidate() {
      return this.model.candidate;
    },

    response() {
      return this.model.response;
    },

    responseId() {
      return this.response ? this.response.id : null;
    },

    responseSpecialProcess() {
      return this.response ? this.response.special_process : null;
    },

    isInternalCandidate() {
      return this.responseSpecialProcess ? this.responseSpecialProcess.is_internal : null;
    },

    vacancy() {
      return this.model.vacancy;
    },

    candidateFullName() {
      return [this.model.candidate.name, this.model.candidate.surname].join(' ');
    },

    createdAt() {
      return this.model.created_at ? this.$moment(this.model.created_at).format('DD.MM') : null;
    },

    invite_creator() {
      if (!this.model || !this.model.creator) {
        return '';
      }

      return this.model.creator.full_name;
    }
  }
};
</script>

<style lang="scss" scoped>
$trbody: #555555;

.vcv-table-row {
  border-bottom: 1px solid #e5e5e5;
  height: 60px;

  td {
    font-size: 16px;
    padding: 23px 6px 20px 10px;

    a {
      color: $trbody;
    }

    .archive-label {
      padding: 2px 8px;
      border-radius: 20px;
      white-space: nowrap;
      display: inline-block;
    }
  }

  .column-checkbox {
    padding: 23px 6px 20px 24px;
  }

  .column-date {
    width: 7%;
  }

  .column-vacancy {
    width: 190px;
  }

  .column-name {
    width: 220px;
  }

  .column-status {
    width: 140px;
  }

  .column-creator {
    width: 190px;
  }

  .row-nowrap {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    a,
    span {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .column-phone {
    width: 190px;
  }
}

td.column-name {
  .column-name-link {
    display: flex;
    .candidate-inner-icon-container {
      padding-left: 2px;
      i {
        font-size: 18px;
        &:hover {
          color: #3eaf29;
        }
      }
    }
  }
}
</style>
